import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Question } from 'core/models/course-content.model';
import { LessonHeader } from 'components/lesson-header/lesson-header';

@Component({
  selector: 'app-question-preview',
  standalone: true,
  imports: [CommonModule, LessonHeader],
  templateUrl: './question-preview.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full h-full flex flex-col',
  },
})
export class QuestionPreview {
  @Input({ required: true }) question!: Question;
  @Input() moduleName?: string;

  protected getQuestionTypeLabel(type: Question['type']): string {
    switch (type) {
      case 'single-choice':
        return 'Seleção Única';
      case 'multiple-choice':
        return 'Seleção Múltipla';
      case 'boolean':
        return 'Verdadeiro/Falso';
      default:
        return '';
    }
  }

  protected getInstructionText(): string {
    switch (this.question.type) {
      case 'multiple-choice':
        return 'Você pode escolher 1 ou mais opções.';
      case 'boolean':
        return 'Escolha uma opção: Verdadeiro ou Falso.';
      default:
        return 'Escolha apenas uma opção.';
    }
  }
}
